import validator from 'validator';

export const emailValidator = (val : string) : boolean => validator.isEmail(val);


